import { render, staticRenderFns } from "./EventApplications.vue?vue&type=template&id=6b20f188&scoped=true&"
import script from "./EventApplications.vue?vue&type=script&lang=js&"
export * from "./EventApplications.vue?vue&type=script&lang=js&"
import style0 from "./EventApplications.vue?vue&type=style&index=0&id=6b20f188&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b20f188",
  null
  
)

export default component.exports